import React from 'react';

const Reviews = () => 
(
        <div>
            <h1>Reviews</h1>
        </div>
);

export default Reviews;